<template>
  <div class="step2">
    <div class="formWrapper formWrapper--horizontal">
      <div class="col-sm-6 formWrapper__inner formWrapper__inner--left">
        <login-form-wrapper  />
      </div>
      <div class="col-sm-6 formWrapper__inner formWrapper__inner--right">
        <div class="continue-as-guest text-center" :class="ifRegister ? 'd-none' : ''">
          <h2>Kontynuuj jako gość</h2>
          <div id="hubspotForm" ref="hubspotForm" @change="setUpAgreements"></div>
          <slot name="continueAsGuest" v-if="hubspotFormSubmitted"></slot>
        </div>
        <register-form-wrapper v-if="ifRegister">
          <template #controls>
            <slot name="continue"></slot>
            <a role="button" class="btn btn-info w-100 mt-3" @click="setRegisterFormVisible(false)">Anuluj</a>
          </template>
        </register-form-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import LoginFormWrapper from '../../components/LoginForm/LoginFormWrapper.vue';
import RegisterFormWrapper from '../../components/RegisterForm/RegisterFormWrapper.vue';
import { checkProductsIsVirtualCard } from '@/utils/categoryUtils';

export default {
  name: 'step2',
  components: {
    RegisterFormWrapper,
    LoginFormWrapper,
  },
  data() {
    return {
      ifRegister: false,
      showDataClause: false,
      hubspotFormSubmitted: false,
      isMarketingMailAgreementCheckedHubspotId: 'LEGAL_CONSENT.subscription_type_9948668',
      isMarketingPhoneAgreementCheckedHubspotId: 'LEGAL_CONSENT.subscription_type_9867041',
    };
  },
  computed: {
    isVirtualCard() {
      return checkProductsIsVirtualCard(this.$store.state.products.all.products[0]);
    },
  },
  methods: {
    setRegisterFormVisible(show) {
      this.ifRegister = show;
    },
    createHubspotForm() {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.head.appendChild(script);
      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: 'na1',
            portalId: '7768293',
            formId: 'abbdbe71-3443-4be6-9534-c21bf67ad759',
            target: '#hubspotForm',
            translations: {
              pl: {
                invalidNumberRangeTooSmall: 'Wpisz poprawny numer NIP',
                invalidNumberRangeTooLarge: 'Wpisz poprawny numer NIP',
              },
            },
          });
          this.setUpHubspotFormObserver();
        }
      });
    },
    setUpHubspotFormObserver() {
      const callback = (mutationList, observer) => {
        if (this.hubspotFormSubmitted) return;
        mutationList.forEach((mutation) => {
          const removedNode = mutation.removedNodes[0];
          if (removedNode && removedNode.tagName === 'FORM') {
            this.handleContinue();
            this.hubspotFormSubmitted = true;
          }
        });
      };
      this.observer = new MutationObserver(callback);
      this.observer.observe(this.$refs.hubspotForm, { childList: true, subtree: true });
    },
    handleContinue() {
      this.$emit('continue', 2);
    },
    setUpAgreements() {
      this.$store.state.additionalInfo.isMarketingMailAgreementChecked = document.getElementsByName(this.isMarketingMailAgreementCheckedHubspotId)[0].checked;
      this.$store.state.additionalInfo.isMarketingPhoneAgreementChecked = document.getElementsByName(this.isMarketingPhoneAgreementCheckedHubspotId)[0].checked;
    },
  },
  mounted() {
    this.createHubspotForm();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style scoped>
  ul{
    list-style: disc;
  }
  li{
    margin-left: 20px;
  }
  .login-box{
    border-right: 1px solid #ccc;
  }
  .privacy-policy {
    font-weight: 500;
  }
</style>
